module.exports = __webpack_public_path__ + "img/微信图片_20210120105912.0afb2fd8.png";